// 引入axios基本配置
import http from '@/api/fetch.js'

/**
 * 登录
 */
export const employeeLogin = (params) => {
  return http({
    url: '/api/v1/login',
    method: 'post',
    data: params
  })
}

/**
 * 退出登录
 */
export const employeeLogout = () => {
    return http({
        url: '/api/v1/logout',
        method: 'post'
    })
}

/**
 * 查询个人资料
 */
export const queryMeInfo = () => {
    return http({
        url: '/api/v1/me/detail',
        method: 'get'
    })
}

/**
 * 修改员工名
 */
export const updateMeUsername = (params) => {
    return http({
        url: '/api/v1/me/username/update',
        method: 'post',
        data: params
    })
}

/**
 * 修改密码
 */
export const updateMePassword = (params) => {
    return http({
        url: '/api/v1/me/password/update',
        method: 'post',
        data: params
    })
}

/**
 * 修改头像
 */
export const updateMePortrait = (params) => {
    return http({
        url: '/api/v1/me/avatar/update',
        method: 'post',
        data: params
    })
}

/**
 * 修改手机号
 */
export const updateMeMobile = (params) => {
    return http({
        url: '/api/v1/me/mobile/update',
        method: 'post',
        data: params
    })
}

/**
 * 修改邮箱
 */
export const updateMeEmail = (params) => {
    return http({
        url: '/api/v1/me/email/update',
        method: 'post',
        data: params
    })
}

/**
 * 查询安全校验信息
 * Verify组件进行安全校验使用
 */
export const querySafetyVerifyInfo = (params) => {
    return http({
        url: '/api/v1/captcha/get',
        method: 'post',
        data: params
    })
}

/**
 * 发送安全校验
 * Verify组件进行安全校验使用
 */
export const sendSafetyVerify = (params) => {
    return http({
        url: '/api/v1/captcha/check',
        method: 'post',
        data: params
    })
}

/**
 * 发送验证码
 */
export const sendVerifyCode = (params) => {
    return http({
        url: '/api/v1/verification_code/send',
        method: 'post',
        data: params
    })
}

/**
 * 校验验证码
 */
export const checkVerifyCode = (params) => {
    return http({
        url: '/api/v1/verification_code/check',
        method: 'get',
        params: params
    })
}

/**
 * 权限
 * 查询权限树
 */
export const queryPermissionTree = () => {
    return http({
        url: '/api/v1/perms/list',
        method: 'get',
    })
}

/**
 * 权限
 * 权限编码校验
 */
export const permissionCheckCode = (params) => {
    return http({
        url: '/api/v1/perms/check',
        method: 'post',
        params: params
    })
}

/**
 * 权限
 * 创建权限
 */
export const createPermission = (params) => {
    return http({
        url: '/api/v1/perms/create',
        method: 'post',
        data: params
    })
}

/**
 * 权限
 * 权限详情
 */
export const queryPermissionDetails = (id) => {
    return http({
        url: `/api/v1/perms/detail?id=${id}`,
        method: 'get'
    })
}

/**
 * 权限
 * 更新权限
 */
export const updatePermission = (params) => {
    return http({
        url: '/api/v1/perms/update',
        method: 'post',
        data: params
    })
}

/**
 * 权限
 * 删除权限
 */
export const deletePermission = (id) => {
    return http({
        url: `/api/v1/perms/delete?id=${id}`,
        method: 'post',
    })
}


/**
 * 角色
 * 角色列表（全部）
 */
export const searchRoleList = () => {
    return http({
        url: '/api/v1/role/list',
        method: 'get'
    })
}

/**
 * 角色
 * 创建角色
 */
export const createRole = (params) => {
    return http({
        url: '/api/v1/role/create',
        method: 'post',
        data: params
    })
}

/**
 * 角色
 * 角色详情
 */
export const queryRoleDetails = (id) => {
    return http({
        url: `/api/v1/role/detail?id=${id}`,
        method: 'get',
    })
}

/**
 * 角色
 * 更新角色
 */
export const updateRole = (params) => {
    return http({
        url: '/api/v1/role/update',
        method: 'post',
        data: params
    })
}

/**
 * 角色
 * 删除角色
 */
export const deleteRole = (id) => {
    return http({
        url: `/api/v1/role/delete?id=${id}`,
        method: 'post',
    })
}

/**
 * 员工
 * 员工列表（分页）
 */
export const queryEmployeeList = (params) => {
    return http({
        url: '/api/v1/employee/list',
        method: 'post',
        data: params
    })
}

/**
 * 员工
 * 创建员工
 */
export const createEmployee = (params) => {
    return http({
        url: '/api/v1/employee/create',
        method: 'post',
        data: params
    })
}

/**
 * 员工
 * 员工详情
 */
export const queryEmployeeDetails = (id) => {
    return http({
        url: `/api/v1/employee/detail?id=${id}`,
        method: 'get',
    })
}

/**
 * 员工
 * 更新员工
 */
export const updateEmployee = (params) => {
    return http({
        url: '/api/v1/employee/update',
        method: 'post',
        data: params
    })
}

/**
 * 员工
 * 删除员工
 */
export const deleteEmployee = (id) => {
    return http({
        url: `/api/v1/employee/delete?id=${id}`,
        method: 'post',
    })
}

/**
 * 员工
 * 重置员工密码
 */
export const resetEmployeePassword = (params) => {
    return http({
        url: '/api/v1/employee/password/reset',
        method: 'post',
        params: params
    })
}

/**
 * 员工
 * 启用员工
 */
export const enableEmployeeList = (id) => {
    return http({
        url: `/api/v1/employee/enable?id=${id}`,
        method: 'post',
    })
}

/**
 * 员工
 * 禁用员工
 */
export const disableEmployeeList = (id) => {
    return http({
        url: `/api/v1/employee/disable?id=${id}`,
        method: 'post',
    })
}
